import React, { useState, useContext, useEffect } from "react";
import { ModalScoreCollaborationContainer, Profile } from "./ModalScoreCollaborationStyled";
import { FormattedMessage } from 'react-intl';

import { CollaborationsContext } from "../../context/collaborationsContext";

import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import { useRef } from "react";
import { UserContext } from "../../context/userContext";
import { postRateCompany, postRateInfluencer } from "../../api/collaborationApi";


export default function ModalScoreCollaboration({ setShowRatePending }) {

    const cardRef = useRef(null);

    const { ratePending, setRatePending } = useContext(CollaborationsContext);
    const { userType, userToken } = useContext(UserContext);

    const [rate, setRate] = useState();

    useEffect(() => {

        function handleClickOutside(event) {
            if (cardRef.current && !cardRef.current.contains(event.target)) {
                setShowRatePending(false)
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [cardRef])

    const sendRate = (event, newValue) => {

        const rateBody = {
            rating: newValue,
            idColaboration: ratePending[0].colaboration_id
        }

        if (userType === 'influencer') {
            postRateCompany({ rateBody: rateBody, token: userToken }).then((response) => {
                const auxRate = ratePending
                auxRate.shift()
                setRatePending(auxRate)
                setShowRatePending(false)
            })

        } else {
            postRateInfluencer({ rateBody: rateBody, token: userToken }).then((response) => {
                const auxRate = ratePending
                auxRate.shift()
                setRatePending(auxRate)
                setShowRatePending(false)
            })
        }
    }

    return (
        <ModalScoreCollaborationContainer>

            <div className="scoreBody" ref={cardRef}>
                <Profile image={(userType === 'influencer') ? (ratePending[0]?.company_imageprofile) : (ratePending[0]?.influencer_imageprofile)} />

                <h2><FormattedMessage id="modal_score_collaboration_title" defaultMessage="Colaboración con" /> <span>{(userType === 'influencer') ? (ratePending[0]?.company_name) : (ratePending[0]?.influencer_name)}</span></h2>

                <p className="textScore"><FormattedMessage id="modal_score_collaboration_text" defaultMessage="¿Cómo calificas tu colaboración con" /> <span>{(userType === 'influencer') ? (ratePending[0]?.company_name) : (ratePending[0]?.influencer_name)}</span>?</p>


                <div className="score">
                    <Stack spacing={1}>
                        {/* <Rating name="size-large" defaultValue={2} size="large" precision={0.5} /> */}

                        <Rating size="large" value={rate} onChange={(event, newValue) => {
                            sendRate(event, newValue)
                        }}
                            icon={<svg xmlns="http://www.w3.org/2000/svg" width="65.839" height="61.243" viewBox="0 0 65.839 61.243">
                                <path id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M64.147,24.055H43.022L36.6,4.9a2.326,2.326,0,0,0-4.366,0L25.817,24.055H4.548a2.3,2.3,0,0,0-2.3,2.3,1.689,1.689,0,0,0,.043.388,2.208,2.208,0,0,0,.962,1.623L20.618,40.6,13.954,59.973a2.3,2.3,0,0,0,.79,2.585,2.222,2.222,0,0,0,1.293.56,2.815,2.815,0,0,0,1.436-.517L34.419,50.523,51.366,62.6a2.691,2.691,0,0,0,1.436.517,2.063,2.063,0,0,0,1.278-.56,2.276,2.276,0,0,0,.79-2.585L48.206,40.6,65.425,28.249l.416-.359a2.409,2.409,0,0,0,.747-1.537A2.432,2.432,0,0,0,64.147,24.055Z" transform="translate(-1.5 -2.625)" fill="#E8339E" stroke="#605858" stroke-width="1.5" />
                            </svg>}
                            emptyIcon={<svg xmlns="http://www.w3.org/2000/svg" width="65.839" height="61.243" viewBox="0 0 65.839 61.243">
                                <path id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M64.147,24.055H43.022L36.6,4.9a2.326,2.326,0,0,0-4.366,0L25.817,24.055H4.548a2.3,2.3,0,0,0-2.3,2.3,1.689,1.689,0,0,0,.043.388,2.208,2.208,0,0,0,.962,1.623L20.618,40.6,13.954,59.973a2.3,2.3,0,0,0,.79,2.585,2.222,2.222,0,0,0,1.293.56,2.815,2.815,0,0,0,1.436-.517L34.419,50.523,51.366,62.6a2.691,2.691,0,0,0,1.436.517,2.063,2.063,0,0,0,1.278-.56,2.276,2.276,0,0,0,.79-2.585L48.206,40.6,65.425,28.249l.416-.359a2.409,2.409,0,0,0,.747-1.537A2.432,2.432,0,0,0,64.147,24.055Z" transform="translate(-1.5 -2.625)" fill="none" stroke="#605858" stroke-width="1.5" />
                            </svg>} />
                    </Stack>
                </div>


            </div>

        </ModalScoreCollaborationContainer>
    )
}